Vue.component('ack-material-comparison-section', {
	delimiters: ['${', '}$'],
	template: '#ack-material-comparison-section',
	props: {
		isVisible: {
			type: Boolean,
			required: false,
			default: true,
		},
		title: {
			type: String,
			required: false,
			default: '',
		},
		sectionData: {
			type: Object,
			required: true,
		},
		sectionClass: {
			type: String,
			required: false,
			default: '',
		},
		titleClass: {
			type: String,
			required: false,
			default: '',
		},
		isMobile: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		resolvedSectionClass() {
			const classes = [this.sectionClass];
			if (this.sectionData && this.sectionData.layout) {
				classes.push(`layout-${this.sectionData.layout}`);
			}
			return classes.filter(Boolean).join(' ');
		},
		displayTitle() {
			return this.title || this.sectionData?.title || '';
		},
		comparisonGridColumnClass() {
			const itemCount = Array.isArray(this.sectionData?.items) ? this.sectionData.items.length : 0;

			if (itemCount === 2) {
				return 'col-12 col-md-6';
			}

			return 'col-12 col-md-4';
		},
		isEnVisionLayout() {
			return (
				this.sectionData &&
				['envision-highlight', 'n2-free-glaze-data'].includes(this.sectionData.layout)
			);
		},
		hasRenderableContent() {
			if (!this.sectionData) {
				return false;
			}

			if (this.isEnVisionLayout) {
				const hasTopContent = Boolean(
					this.sectionData.topLeft ||
						(this.sectionData.topRight && this.sectionData.topRight.image),
				);
				const hasItems = Array.isArray(this.sectionData.items) && this.sectionData.items.length > 0;
				return hasTopContent || hasItems;
			}

			return Array.isArray(this.sectionData.items) && this.sectionData.items.length > 0;
		},
		enVisionPoints() {
			if (!this.sectionData || !this.sectionData.topLeft) {
				return [];
			}

			if (!Array.isArray(this.sectionData.topLeft.points)) {
				return [];
			}

			return this.sectionData.topLeft.points.filter((point) => Boolean(point));
		},
	},
});
